import * as konvives from './list'

export const allKonvives = Object.values(konvives).sort(
    (previous, current) =>
        previous.last_name.localeCompare(current.last_name) ||
        previous.first_name.localeCompare(current.first_name),
)
